

export const Loading = () => {
  return (
    <div className="flex justify-center space-x-4">
      <img
        src="https://acegif.com/wp-content/uploads/loading-23.gif"
        alt="Img not found"
        width="1000px"
        height={"1000px"}
      />
    </div>
  );
}